// ---------------------------------------------------------------------------
// useManagementViewConfig
//
// Thin wrapper around `useApi` that fetches the Management View bootstrap
// config (`GET /api/management-view/config`). The page uses the response's
// `visibleTabs` array to drive its tab list — role-driven gating happens on
// the server, the page never decides locally which tabs a role should see.
// ---------------------------------------------------------------------------

import { useApi, type UseApiResult } from './useApi';
import { managementViewApi } from '@/services/management-view-api';
import type { IManagementViewConfig } from '@skystone/shared';

/** One-shot fetch of the Management View page's tab + filter-default config. */
export function useManagementViewConfig(): UseApiResult<IManagementViewConfig> {
  return useApi<IManagementViewConfig>(() => managementViewApi.getConfig(), []);
}
